var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"VideoParser"}},[_c('video',{staticClass:"img-fluid animate__animated animate__fadeIn",attrs:{"autoplay":_vm.autoplay,"poster":"/img/video_backgrounds/purple.jpg","src":_vm.content,"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }